import { titleColor } from './common'
/** 当月订单前五 */
export default data => {
  const legendData = []
  const seriesData = []
  data.forEach(item => {
    legendData.push(item.x)
    seriesData.push({ name: item.x, value: item.y })
  })
  return {
    title: {
      text: '支付情况统计',
      textStyle: {
        color: titleColor,
        fontSize: 30
      },
      textAlign: 'left'
    },
    textStyle: {
      color: '#fff'
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    legend: {
      type: 'scroll',
      orient: 'vertical',
      left: 10,
      top: 40,
      bottom: 0,
      data: legendData,
      textStyle: {
        fontSize: 22,
        fontWeight: 'bold',
        lineHeight: 32
      }
    },
    series: [
      {
        type: 'pie',
        label: {
          show: true,
          fontSize: 20
        },
        center: ['60%', '50%'],
        startAngle: 270,
        redius: '55%',
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        },
        data: seriesData
        // encode: {
        //   y: 'amount',
        //   x: 'date'
        // }
      }
    ]
  }
}
